// extracted by mini-css-extract-plugin
export default {"btnLg":"EmptyCart_btnLg__NG4oe","btnStyle":"EmptyCart_btnStyle__zTul1","fadein":"EmptyCart_fadein__YPawz","btN":"EmptyCart_btN__pkO9Y"};